// extracted by mini-css-extract-plugin
export var col = "Column-module__col___4jKF4";
export var col1 = "Column-module__col1___agABx";
export var col10 = "Column-module__col10___cc+tl";
export var col11 = "Column-module__col11___fQZu8";
export var col12 = "Column-module__col12___Gy9Zv";
export var col2 = "Column-module__col2___yAfS9";
export var col3 = "Column-module__col3___R1Hiw";
export var col4 = "Column-module__col4___9cd1Z";
export var col5 = "Column-module__col5___KZjIH";
export var col6 = "Column-module__col6___bJtVk";
export var col7 = "Column-module__col7___qlZ8f";
export var col8 = "Column-module__col8___Phk+C";
export var col9 = "Column-module__col9___+-PMs";
export var colLg1 = "Column-module__colLg1___VAMG+";
export var colLg10 = "Column-module__colLg10___xnDLH";
export var colLg11 = "Column-module__colLg11___jhOBf";
export var colLg12 = "Column-module__colLg12___l5Yi1";
export var colLg2 = "Column-module__colLg2___8B430";
export var colLg3 = "Column-module__colLg3___TUCjn";
export var colLg4 = "Column-module__colLg4___HMHmr";
export var colLg5 = "Column-module__colLg5___R3On-";
export var colLg6 = "Column-module__colLg6___RZLYI";
export var colLg7 = "Column-module__colLg7___tvAA+";
export var colLg8 = "Column-module__colLg8___tEdjC";
export var colLg9 = "Column-module__colLg9___oBfDR";
export var colMd1 = "Column-module__colMd1___Edc0z";
export var colMd10 = "Column-module__colMd10___+1nhw";
export var colMd11 = "Column-module__colMd11___dt21V";
export var colMd12 = "Column-module__colMd12___2pyp1";
export var colMd2 = "Column-module__colMd2___ZDTX1";
export var colMd3 = "Column-module__colMd3___CVJZf";
export var colMd4 = "Column-module__colMd4___l17if";
export var colMd5 = "Column-module__colMd5___15KlR";
export var colMd6 = "Column-module__colMd6___Xo+6D";
export var colMd7 = "Column-module__colMd7___vUI-Y";
export var colMd8 = "Column-module__colMd8___bouCy";
export var colMd9 = "Column-module__colMd9___WiO5g";
export var colSm1 = "Column-module__colSm1___PC8JL";
export var colSm10 = "Column-module__colSm10___Fg43F";
export var colSm11 = "Column-module__colSm11___Q9VJs";
export var colSm12 = "Column-module__colSm12___bmVxO";
export var colSm2 = "Column-module__colSm2___RXTOu";
export var colSm3 = "Column-module__colSm3___8b7Ke";
export var colSm4 = "Column-module__colSm4___EuqCs";
export var colSm5 = "Column-module__colSm5___zfS+q";
export var colSm6 = "Column-module__colSm6___phLiy";
export var colSm7 = "Column-module__colSm7___dvH8B";
export var colSm8 = "Column-module__colSm8___lbYBl";
export var colSm9 = "Column-module__colSm9___7nK+v";
export var large = "1084px";
export var medium = "860px";
export var small = "540px";